import { render } from "./Delete.vue?vue&type=template&id=780bfb2c&scoped=true"
const script = {}

import "./Delete.vue?vue&type=style&index=0&id=780bfb2c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780bfb2c"]])

export default __exports__